export class MenuModel {
    public id :string;
    public name:string;
    public createDate:string;
    public venues:Array<{venueId: string}>;
    public venueMenuCategories: Array<any>;
}
